import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

const SuccessIcon = ({ success, size, ...rest }) => (
  <StyledSuccessIcon {...rest} size={size} success={success}>
    {success ? <StyledCheck /> : <StyledCross />}
  </StyledSuccessIcon>
);

SuccessIcon.propTypes = {
  className: PropTypes.string,
  success: PropTypes.bool,
  size: PropTypes.number,
};

SuccessIcon.defaultProps = {
  className: '',
  size: 60,
  success: true,
};

const StyledCheck = styled.div`
  position: relative;
  display: inline-block;

  &::after {
    content: '';
    position: absolute;
    height: 50%;
    left: 0;
    right: 0;
    background: none;
    border-left: 2px solid;
    border-bottom: 2px solid;
    transform: rotate(-45deg) translateX(-5%) translateY(5%);
    border-color: #ffffff;
  }
`;

const StyledCross = styled.div`
  position: relative;
  display: inline-block;

  &::before,
  &::after {
    content: '';
    position: absolute;
    height: 5%;
    min-height: 1px;
    max-height: 3px;
    width: 100%;
    top: 50%;
    left: 0;
    margin-top: -1px;
    background: #ffffff;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;

const StyledSuccessIcon = styled.div`
  min-width: 15px;
  min-height: 15px;
  border-radius: 100%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-align: start;
  ${({ size }) => css`
    width: ${size}px;
    height: ${size}px;
  `};
  background-color: #ffffff;
  background-image: ${props =>
    props.success
      ? css`linear-gradient(to right, rgb(0, 224, 75), rgb(0, 176, 182));`
      : css`linear-gradient(to top, rgb(255, 128, 0), rgb(207, 0, 69))`};

  ${StyledCheck},
  ${StyledCross} {
    ${({ size }) => css`
      width: ${size / 2}px;
      height: ${size / 2}px;
    `}
  }
`;

export default SuccessIcon;
